import React, { useEffect } from 'react';
import '../../../assets/css/views/free-strategy.css';

export default function FreeStrategy() {
  useEffect(() => {
    // Load Calendly's external widget script
    const scriptId = 'calendly-widget-script';
    if (document.getElementById(scriptId)) return;

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);

    // Function to handle messages from the Calendly iframe
    const handleCalendlyEvent = (e) => {
      if (e.data.event && e.data.event === 'calendly.event_scheduled') {
        console.log('Calendly event scheduled:', e.data.payload);
        if (window.fbq) {
          window.fbq('track', 'Schedule', {
            content_category: 'Free Strategy Session'
          });
        }
      }
    };

    // Add event listener for messages from iframes
    window.addEventListener('message', handleCalendlyEvent);

    // Cleanup function to remove the script and event listener
    return () => {
      window.removeEventListener('message', handleCalendlyEvent);
      const existingScript = document.getElementById(scriptId);
      if (existingScript) document.head.removeChild(existingScript);
    };
  }, []);

  return (
    <div className="earn-hero">
      <div className="earn-hero__text">
        <h1 className="earn-hero__header">Free Marketing Strategy & Brainstorm Session</h1>
        <p className="earn-hero__description">
          Schedule a free 60-minute session to discuss your marketing goals. Together we'll audit your current strategy, brainstorm new ideas, and show you where Amplify Loyalty fits into your marketing funnel.
        </p>
      </div>
      <div className="earn-hero__calendly-container">
        <div 
          className="calendly-inline-widget" 
          data-url="https://calendly.com/trevor-amplifyloyalty/free-marketing-strategy-audit-brainstorm?hide_gdpr_banner=1" 
          style={{ minWidth: '320px', height: '700px' }}
        ></div>
      </div>
    </div>
  );
}
